/* eslint-disable no-undef */
/**
 * .env Exports
 */
export const env_backend_url = process.env?.REACT_APP_BACKEND
  ? process.env.REACT_APP_BACKEND
  : window.location.protocol + '//' + window.location.host + '';
export const env_public_url = process.env.PUBLIC_URL;
